import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { lowLqiSignalThreshold } from '@common';
import { InstallationFeaturesStore } from '@store';

import {
  DcSensorValueProperties,
  DeviceConnectionStatus,
  DeviceFirmwareVersion,
  DeviceNameCommands,
  DeviceNameProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  SignalProperties,
} from '@vi-iot/client';
import { NO_VALUE } from 'src/app/shared/pipes/dash/dash.pipe';
import { MatDialog } from '@angular/material/dialog';
import { EditDeviceNameModalComponent } from 'src/app/+installations/single-room-control/edit-device-name-modal/edit-device-name-modal.component';
import { InstallationService } from 'src/app/+installations/services/installation.service';
import { GTMService } from '@services';
@Component({
  selector: 'app-ventilation-remote-controller-readings',
  templateUrl: './ventilation-remote-controller-readings.component.html',
  styleUrls: ['./ventilation-remote-controller-readings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VentilationRemoteControllerReadingsComponent implements OnInit {
  readonly lowLqiSignalThreshold = lowLqiSignalThreshold;
  readonly featurePropertyKey = FeaturePropertyKey;

  wifiLqi$: Observable<Feature<SignalProperties, never>>;
  temperature$: Observable<Feature<DcSensorValueProperties, never>>;
  humidity$: Observable<Feature<DcSensorValueProperties, never>>;
  status$: Observable<Feature<DeviceConnectionStatus, never>>;
  firmware$: Observable<Feature<DeviceFirmwareVersion, never>>;
  deviceName$: Observable<Feature<DeviceNameProperties, DeviceNameCommands>>;

  noValue = NO_VALUE;

  @Input() deviceId: string;

  constructor(
    public installationService: InstallationService,
    public installationFeaturesStore: InstallationFeaturesStore,
    private dialog: MatDialog,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.wifiLqi$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceZigbeeLqi,
      this.deviceId
    );
    this.temperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceTemperatureSensor,
      this.deviceId
    );
    this.humidity$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceHumiditySensor,
      this.deviceId
    );
    this.status$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceConnection,
      this.deviceId
    );
    this.firmware$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.essFirmwareBundle,
      this.deviceId
    );
    this.deviceName$ = this.installationFeaturesStore.selectInstallationDeviceFeature<
      DeviceNameProperties,
      DeviceNameCommands
    >(FeatureNames.deviceName, this.deviceId);
  }
  openEditDeviceNameDialog(deviceId: string): void {
    this.gtmService.track('onOpen', 'Edit Device Name modal', 'singleRoomControl');
    this.dialog.open(EditDeviceNameModalComponent, {
      width: '715px',
      panelClass: 'commissioning-edit-room-dialog',
      data: {
        deviceId,
      },
    });
  }
}
